import { render, staticRenderFns } from "./KoExc.vue?vue&type=template&id=5a2891cd"
import script from "./KoExc.vue?vue&type=script&lang=js"
export * from "./KoExc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports